import { MouseEvent } from "react";

const stopPropagation = (callback?: () => void) => (e?: MouseEvent) => {
  e?.stopPropagation();
  callback?.();
};

export default stopPropagation;
